import { put } from 'redux-saga/effects';
import { getLocalStorage } from '../../utility/localStorage';
import { LOGIN_COMPLETE } from '../actionType';

export default function* localStorageSaga() {
    const token = yield getLocalStorage();

    yield put({ type: LOGIN_COMPLETE, token: token });
}
